<template>
  <div class="d-inline-block align-middle calendar-navigator position-relative">
    <div class="form-control gray-input d-flex align-items-center justify-content-center">
      <a class="calendar-navigator__left" @click="prev">
        <LeftSvg/>
      </a>
      <span class="nowrap pointer" @click="dateClicked">{{ title }}</span>
      <a class="calendar-navigator__right" @click="next">
        <RightSvg/>
      </a>
      <div v-if="show" v-click-outside="clickedOutside">
      <DatePicker :locale="{ id: 'ru', firstDayOfWeek: 2, masks: { L: 'DD.MM.YYYY' } }"
                  class="date-picker"
                  :class="{ left: left }"
                  @input="handleInput"
                  @dayclick="handleInput"
                  v-model="day"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import RightSvg from '@/assets/svg-vue/general/arrow_right.svg'
import LeftSvg from '@/assets/svg-vue/general/arrow_left.svg'
import { DatePicker } from 'v-calendar'
import moment from "moment/moment"
import { computed, ref, watch } from "vue"

defineProps({
  left: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['daySelected'])

const show = ref(false)
// the click that opens the picker is not taken as an outside one
let justOpened = false
const day = ref(new Date())

const title = computed(() => moment(day.value).format('DD MMMM YYYY'))

const next = () => {
  day.value = moment(day.value).add(1, 'days').toDate()
}

const prev = () => {
  day.value = moment(day.value).add(-1, 'days').toDate()
}

const dateClicked = () => {
  show.value = !show.value
  justOpened = true
  setTimeout(() => {
    justOpened = false
  },20)
}

const handleInput = (e) => {
  show.value = false
  day.value = e.date
}

const clickedOutside = () => {
  if(!justOpened) {
    show.value = false
  }
}

watch(day, (val) => {
  emit('daySelected', moment(val).format('YYYY-MM-DD'))
})

// CRMGeneral sets the day back to today
defineExpose({
  day,
})
</script>
